/* note 1 */

/* ---------- 1. image failsafe ---------- */
(function(){
/* note 2 */
(function(){
  /* note 3 */
  var SEL='.card-media img,img[src*="cdn.shopify.com"],img[src*="/cdn/shop/"]:not(.logo-img)';
  var SHOWN="loaded";              /* the class .card-media img.loaded fades in on */
  var ph=null;

  /* A flat placeholder in the page's own tokens: a tinted ground, a small disc
     and a low horizon. No text, so it needs no translation. */
  function placeholder(){
    if(ph) return ph;
    var cs=getComputedStyle(document.documentElement);
    function tok(name,fallback){
      var v=(cs.getPropertyValue(name)||"").trim();
      return v||fallback;
    }
    var ground=tok("--blush-deep","#F5E7E2"), mark=tok("--cream","#FDF9F6");
    ph="data:image/svg+xml,"+encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="100" viewBox="0 0 80 100">'+
      '<rect width="80" height="100" fill="'+ground+'"/>'+
      '<circle cx="54" cy="30" r="8" fill="'+mark+'" opacity=".85"/>'+
      '<path d="M0 72 30 44 52 66 80 42 80 100 0 100Z" fill="'+mark+'" opacity=".85"/>'+
      '</svg>');
    return ph;
  }

  function reveal(img){ img.classList.add(SHOWN); }

  function fail(img){
    if(img.getAttribute("data-jk-failed")){ reveal(img); return; }
    img.setAttribute("data-jk-failed","1");
    /* srcset and sizes outrank src, so both have to go before the swap */
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src=placeholder();
    reveal(img);
  }
  window.jkImgFail=fail;                 /* used by the inline onerror on built cards */

  function watch(img){
    if(img.getAttribute("data-jk-img")) return;
    img.setAttribute("data-jk-img","1");
    if(img.complete){                    /* cached, or already failed, before we bound */
      if(img.naturalWidth>0) reveal(img); else fail(img);
      return;
    }
    img.addEventListener("load",function(){ reveal(img); });
    img.addEventListener("error",function(){ fail(img); });
  }

  function sweep(){
    var list=document.querySelectorAll(SEL);
    for(var i=0;i<list.length;i++) watch(list[i]);
  }

  var queued=false;
  function schedule(){
    if(queued) return;
    queued=true;
    var run=function(){ queued=false; sweep(); };
    if(window.requestAnimationFrame) window.requestAnimationFrame(run); else setTimeout(run,0);
  }

  sweep();
  document.addEventListener("DOMContentLoaded",sweep);
  window.addEventListener("load",sweep);
  try{
    if(window.MutationObserver){
      new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
    }
  }catch(e){}
})();
})();

/* ---------- 2. motion layer ---------- */
(function(){
/* note 4 */
(function(){
  var root=document.documentElement;
  var hidden=[];

  function release(){
    root.classList.remove("gs");
    hidden.forEach(function(el){
      el.style.opacity="";el.style.transform="";el.classList.remove("gs-anim");
    });
    hidden.length=0;
  }

  if(!root.classList.contains("gs")) return;                 /* reduced motion, or a failsafe fired */
  if(!window.gsap||!window.ScrollTrigger){release();return;}  /* CDN blocked or partially loaded */

  try{
    gsap.registerPlugin(ScrollTrigger);
    var EASE="power2.out";
    var toArray=gsap.utils.toArray;
    var cardTriggers=[];
    var LOAD_AT=.5;       /* the hero copy has landed by here */
    var STEP=.12;         /* one group behind the next, so the screen reads as one entrance */

    /* note 5 */
    function vh(){return window.innerHeight||root.clientHeight||0;}
    /* -1 already scrolled past, 0 on the first screen, 1 below the fold */
    function place(el){
      var r=el.getBoundingClientRect();
      if(r.bottom<=0) return -1;
      return r.top<vh()?0:1;
    }

    /* Hidden and not yet handed to a reveal. The sweep is allowed to touch these
       and nothing else, so nothing animates twice. */
    var pending=[];
    function hold(els){els.forEach(function(el){if(pending.indexOf(el)<0)pending.push(el);});return els;}
    function claim(els){els.forEach(function(el){var i=pending.indexOf(el);if(i>=0)pending.splice(i,1);});}
    function prune(){pending=pending.filter(function(el){return root.contains(el);});}

    function childrenOf(host){return host?Array.prototype.slice.call(host.children):[];}
    function unlock(){this.targets().forEach(function(el){el.classList.remove("gs-anim");});}

    function hide(els,y){
      if(!els||!els.length) return els||[];
      els.forEach(function(el){
        el.classList.add("gs-anim");
        if(hidden.indexOf(el)<0) hidden.push(el);
      });
      hold(els);
      gsap.set(els,{opacity:0,y:y});
      return els;
    }
    function show(els,stagger,duration,delay){
      claim(els);
      return gsap.to(els,{
        opacity:1,y:0,duration:duration||.8,stagger:stagger||0,delay:delay||0,ease:EASE,
        overwrite:true,clearProps:"transform",onComplete:unlock
      });
    }
    function shown(els){
      if(!els.length) return;
      claim(els);
      els.forEach(function(el){el.classList.remove("gs-anim");});
      gsap.set(els,{opacity:1,y:0,clearProps:"transform"});
    }

    /* note 6 */
    var groups=[];
    function reveal(trigger,els,stagger,duration,batch,sel){
      els=els||[];
      if(!els.length && !sel) return;
      groups.push({trigger:trigger||els[0]||null,els:els,stagger:stagger||0,
                   duration:duration||.8,batch:!!batch,sel:sel||null});
    }

    /* note 7 */
    var heroCopy=document.querySelector(".hero-copy");
    var heroKids=childrenOf(heroCopy);
    var heroImg=document.querySelector(".hero-media img");
    hide(heroKids,22);
    claim(heroKids);                                   /* the hero animates on load, always */
    if(heroImg){
      heroImg.classList.add("gs-anim");
      hidden.push(heroImg);
      gsap.set(heroImg,{opacity:0,scale:1.05});
    }

    /* Everything else. */
    toArray(".sec-head").forEach(function(head){
      reveal(head,hide(childrenOf(head),18),.08,.75);
    });
    var edMedia=document.querySelector(".ed-media");
    if(edMedia) reveal(edMedia,hide([edMedia],22),0,.9);
    var edCopy=document.querySelector(".ed-copy");
    if(edCopy) reveal(edCopy,hide(childrenOf(edCopy),18),.07,.8);
    reveal(null,hide(toArray(".cats .cat"),22),.08,.8,true);
    /* the age row enters as one group with its own small heading, so the second
       half of the category section reads as a single move rather than four */
    reveal(null,hide(toArray(".ages-head, .ages .age"),20),.08,.75,true);
    reveal(null,hide(toArray(".says .say"),20),.08,.75,true);
    reveal(null,hide(toArray(".assure-item"),20),.08,.75,true);
    reveal(null,hide(toArray("#grid .card"),26),.07,.8,true,"#grid .card");

    /* note 8 */
    root.classList.remove("gs");

    /* note 9 */
    if(heroKids.length){
      gsap.to(heroKids,{opacity:1,y:0,duration:.7,stagger:.09,delay:.06,ease:EASE,
        clearProps:"transform",onComplete:unlock});
    }
    if(heroImg){
      gsap.to(heroImg,{opacity:1,scale:1,duration:1.3,delay:.1,ease:EASE,
        clearProps:"transform",onComplete:unlock});
    }

    function batchCards(list){
      cardTriggers.forEach(function(t){t.kill();});
      cardTriggers=[];
      if(!list.length) return;
      cardTriggers=ScrollTrigger.batch(list,{
        start:"top 85%",once:true,
        onEnter:function(batch){show(batch,.07,.8);}
      })||[];
    }

    var armed=false;
    function armCore(){
      var now=[];
      groups.forEach(function(g){
        if(g.sel){ g.els=toArray(g.sel); hold(g.els); }
        var here=[],late=[],passed=[];
        g.els.forEach(function(el){
          var p=place(el);
          if(p<0) passed.push(el); else if(p>0) late.push(el); else here.push(el);
        });
        /* already off the top of the screen: there is no entrance to watch */
        shown(passed);
        if(here.length) now.push({top:here[0].getBoundingClientRect().top,g:g,els:here});
        if(!late.length) return;
        if(g.sel){ batchCards(late); return; }
        if(g.batch){
          ScrollTrigger.batch(late,{start:"top 85%",once:true,
            onEnter:function(batch){show(batch,g.stagger,g.duration);}});
          return;
        }
        ScrollTrigger.create({
          trigger:(late.length===g.els.length)?(g.trigger||late[0]):late[0],
          start:"top 85%",once:true,
          onEnter:function(){show(late,g.stagger,g.duration);}
        });
      });
      /* One coordinated entrance for the first screen: the hero, then whatever else
         that screen already holds, in the order it is read down the page. */
      now.sort(function(a,b){return a.top-b.top;});
      now.forEach(function(item,i){
        show(item.els,item.g.stagger,item.g.duration,LOAD_AT+i*STEP);
      });
      ScrollTrigger.refresh();
    }
    function arm(){
      if(armed) return;
      armed=true;
      try{armCore();}catch(err){release();}
    }

    /* note 10 */
    function sweep(){
      if(!armed) return;          /* arm() is already scheduled, and it does this job itself */
      try{
        prune();
        var due=pending.filter(function(el){return place(el)===0;});
        if(due.length) show(due,.06,.55);
      }catch(err){release();}
    }

    /* Two frames: long enough for the band to have been measured and for the
       automatic switch to Arabic to have re-rendered the grid. */
    if(window.requestAnimationFrame){
      requestAnimationFrame(function(){requestAnimationFrame(arm);});
    }
    setTimeout(arm,150);                       /* backstop if frames are throttled */

    /* note 11 */
    function bindCards(){
      prune();
      var cards=toArray("#grid .card");
      if(!cards.length){batchCards([]);return;}
      if(!armed){hide(cards,26);return;}        /* the load pass has not run yet */
      var below=[],seen=[];
      cards.forEach(function(card){ (place(card)>0?below:seen).push(card); });
      shown(seen);
      batchCards(hide(below,26));
    }

    /* note 12 */
    window.onGridRender=function(){
      bindCards();
      requestAnimationFrame(function(){ScrollTrigger.refresh();sweep();});
    };
    var langBtn=document.getElementById("langBtn");
    if(langBtn) langBtn.addEventListener("click",function(){
      if(window.requestAnimationFrame) requestAnimationFrame(sweep);
      setTimeout(sweep,450);
    });
    if(document.fonts&&document.fonts.ready){
      document.fonts.ready.then(function(){ScrollTrigger.refresh();sweep();});
    }
    window.addEventListener("load",function(){ScrollTrigger.refresh();sweep();});
    var rz=0;
    window.addEventListener("resize",function(){
      clearTimeout(rz);
      rz=setTimeout(function(){ScrollTrigger.refresh();sweep();},150);
    },{passive:true});
    setTimeout(sweep,1200);

    /* note 13 */
    setTimeout(function(){
      if(!hidden.length) return;
      var probe=heroKids && heroKids.length ? heroKids[0] : hidden[0];
      if(!probe) return;
      var op=parseFloat(window.getComputedStyle(probe).opacity);
      if(!(op>0.05)){
        try{ gsap.globalTimeline.clear(); }catch(e){}
        release();
      }
    },2500);

    /* And when a backgrounded tab is finally brought forward, let whatever was
       waiting arrive rather than sit. */
    document.addEventListener("visibilitychange",function(){
      if(document.visibilityState!=="visible") return;
      try{ ScrollTrigger.refresh(); sweep(); }catch(e){ release(); }
    });

    /* Keyboard users must never land on an element that has not revealed yet. */
    document.addEventListener("focusin",function(e){
      var t=(e.target&&e.target.nodeType===1)?e.target:null;
      if(!t) return;
      for(var i=0;i<pending.length;i++){
        if(pending[i].contains(t)){show([pending[i]],0,.25);return;}
      }
    });
  }catch(err){
    release();
  }
})();
})();

/* ---------- 3. floating buttons ---------- */

(function(){
  var top=document.querySelector('.fab-top'); if(!top) return;
  /* note 14 */
  var hdr=document.querySelector('header');
  var onScroll=function(){
    top.classList.toggle('on', window.scrollY>600);
    if(hdr) hdr.classList.toggle('scrolled', window.scrollY>4);
  };
  /* note 15 */
  var stack=document.querySelector('.fab-stack');
  var foot=document.querySelector('footer');
  var hero=document.querySelector('.hero');
  var ticking=false;
  /* note 16 */
  /* note 17 */
  var AVOID='a,button,input,select,textarea,label,summary,[role="button"],[role="link"],[tabindex]:not([tabindex="-1"]),h1,h2,h3,h4,.prd-price,.card-total-summa,.facts li,[data-fab-avoid]';
  /* The interactive half of AVOID. A hit has to be a control to be treated as
     primary - a wide <h1> is not an action and must not empty the corner. */
  var PRIMARY='a,button,input,select,textarea,label,summary,[role="button"],[role="link"],[tabindex]:not([tabindex="-1"]),[data-fab-avoid]';
  var covers=function(box){
    var els=document.querySelectorAll(AVOID);
    for(var i=0;i<els.length;i++){
      var hit=els[i];
      if(stack.contains(hit)) continue;
      var r=hit.getBoundingClientRect();
      /* Cheap rejects first: a zero box is a hidden control, and four
         comparisons throw out everything not in the corner before any
         multiplication happens. */
      if(r.width===0||r.height===0) continue;
      if(r.right<=box.left||r.left>=box.right||r.bottom<=box.top||r.top>=box.bottom) continue;
      var w=Math.min(r.right,box.right)-Math.max(r.left,box.left);
      var h=Math.min(r.bottom,box.bottom)-Math.max(r.top,box.top);
      /* note 18 */
      if(r.width>=window.innerWidth*0.6&&hit.matches(PRIMARY)) return true;
      if((w*h)/(r.width*r.height)>0.25) return true;
    }
    return false;
  };
  var park=function(){
    if(!stack||!foot) return;
    var over=window.innerHeight-foot.getBoundingClientRect().top;
    stack.style.setProperty('--fab-lift',(over>0?Math.round(over):0)+'px');
    /* note 19 */
    var head=document.querySelector('header');
    var edge=head?head.getBoundingClientRect().bottom:0;
    var box=stack.getBoundingClientRect();
    var atHeader=box.top < edge+8;
    /* note 20 */
    var onHero=!!hero && hero.getBoundingClientRect().bottom > box.top;
    /* note 21 */
    stack.classList.toggle('is-tucked', atHeader || onHero || covers(box));
  };
  var onScrollFab=function(){
    onScroll();
    if(!ticking){ ticking=true; requestAnimationFrame(function(){ ticking=false; park(); }); }
  };
  window.addEventListener('scroll',onScrollFab,{passive:true});
  window.addEventListener('resize',park,{passive:true});
  onScrollFab(); park();
  top.addEventListener('click',function(){
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top:0,behavior:reduce?'auto':'smooth'});
  });
  var lang=document.getElementById('langBtn');
  if(lang) lang.addEventListener('click',function(){
    var ar=document.documentElement.dir==='rtl';
    document.querySelectorAll('[data-fab-en]').forEach(function(el){
      el.setAttribute('aria-label', ar?el.getAttribute('data-fab-ar'):el.getAttribute('data-fab-en'));
    });
  });
})();

/* note 22 */
(function(){
  document.addEventListener('click',function(e){
    var near=e.target.closest&&e.target.closest('.prd-size-guide-link');
    if(!near) return;
    /* note 23 */
    var host=document.querySelector('info-popup[data-ajax*="size-guide"]');
    if(!host) return;
    var link=host.querySelector('a.modal-info-link');
    if(!link) return;
    e.preventDefault();
    link.click();
  });
})();

/* note 24 */
(function(){
  var LIST='#curList', BTN='#curBtn';
  var list=function(){ return document.querySelector(LIST); };
  var btn=function(){ return document.querySelector(BTN); };

  var setOpen=function(open){
    var l=list(), b=btn();
    if(!l||!b) return;
    if(open){ l.removeAttribute('hidden'); } else { l.setAttribute('hidden',''); }
    b.setAttribute('aria-expanded', open?'true':'false');
  };
  var isOpen=function(){ var l=list(); return !!l && !l.hasAttribute('hidden'); };

  var choose=function(li){
    var l=list(), b=btn();
    if(!l||!b||!li) return;
    l.querySelectorAll('.fsw-opt').forEach(function(o){ o.setAttribute('aria-selected','false'); });
    li.setAttribute('aria-selected','true');
    var flag=b.querySelector('#curFlag'), val=b.querySelector('#curVal'), nm=b.querySelector('#curName');
    var img=li.querySelector('img');
    if(flag&&img) flag.src=img.getAttribute('src');
    if(val) val.textContent=li.getAttribute('data-shown')||li.getAttribute('data-cur')||'';
    if(nm) nm.textContent=li.getAttribute('data-name')||'';
    setOpen(false);
    b.focus();
  };

  document.addEventListener('click',function(e){
    var t=e.target;
    if(!t||!t.closest) return;
    var b=t.closest(BTN);
    if(b){ e.preventDefault(); setOpen(!isOpen()); return; }
    var opt=t.closest('.fsw-opt');
    if(opt&&opt.closest(LIST)){ e.preventDefault(); choose(opt); return; }
    /* any click that is not on the control closes it */
    if(isOpen() && !t.closest('.fsw-cur')) setOpen(false);
  });

  document.addEventListener('keydown',function(e){
    if(!isOpen()){
      /* opening from the button with the keyboard */
      if((e.key==='Enter'||e.key===' ')&&e.target&&e.target.closest&&e.target.closest(BTN)){
        e.preventDefault(); setOpen(true);
        var first=list().querySelector('.fsw-opt[aria-selected="true"]')||list().querySelector('.fsw-opt');
        if(first) first.focus();
      }
      return;
    }
    var l=list();
    var opts=[].slice.call(l.querySelectorAll('.fsw-opt'));
    var cur=document.activeElement&&document.activeElement.closest?document.activeElement.closest('.fsw-opt'):null;
    var i=opts.indexOf(cur);
    if(e.key==='Escape'){ e.preventDefault(); setOpen(false); btn().focus(); return; }
    if(e.key==='ArrowDown'){ e.preventDefault(); (opts[i+1]||opts[0]).focus(); return; }
    if(e.key==='ArrowUp'){ e.preventDefault(); (opts[i-1]||opts[opts.length-1]).focus(); return; }
    if((e.key==='Enter'||e.key===' ')&&cur){ e.preventDefault(); choose(cur); return; }
  });
})();


/* Sort control. Same shape as the currency switcher above, with one difference
   that matters: it writes back to the native <select> and dispatches `change`,
   because `facet-sort-by` is vendor JS listening for exactly that event. The
   select stays the source of truth; this is only a skin over it.

   Scoped per .jsort instance rather than by id, so a second one on the page
   cannot drive the first. Delegated on document, per the project rule. */
(function(){
  function listOf(root){ return root.querySelector('.jsort-list'); }
  function btnOf(root){ return root.querySelector('.jsort-sel'); }

  function setOpen(root, open){
    var l=listOf(root), b=btnOf(root);
    if(!l||!b) return;
    if(open){ l.removeAttribute('hidden'); } else { l.setAttribute('hidden',''); }
    b.setAttribute('aria-expanded', open?'true':'false');
  }
  function isOpen(root){ var l=listOf(root); return !!l && !l.hasAttribute('hidden'); }

  function choose(root, li){
    var l=listOf(root), b=btnOf(root);
    if(!l||!b||!li) return;
    l.querySelectorAll('.jsort-opt').forEach(function(o){ o.setAttribute('aria-selected','false'); });
    li.setAttribute('aria-selected','true');
    var val=b.querySelector('.jsort-val');
    if(val) val.textContent=li.textContent;
    /* the part that actually sorts */
    var sel=root.querySelector('.jsort-native');
    var v=li.getAttribute('data-value');
    if(sel && v!==null && sel.value!==v){
      sel.value=v;
      sel.dispatchEvent(new Event('change',{bubbles:true}));
    }
    setOpen(root,false);
    b.focus();
  }

  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var b=t.closest('.jsort-sel');
    if(b){ e.preventDefault(); var r=b.closest('.jsort'); setOpen(r,!isOpen(r)); return; }
    var opt=t.closest('.jsort-opt');
    if(opt){ e.preventDefault(); choose(opt.closest('.jsort'),opt); return; }
    /* a click anywhere else closes any open one */
    document.querySelectorAll('.jsort').forEach(function(r){
      if(isOpen(r) && !t.closest('.jsort')) setOpen(r,false);
    });
  });

  document.addEventListener('keydown',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var root=t.closest('.jsort'); if(!root) return;
    if(!isOpen(root)){
      if((e.key==='Enter'||e.key===' ')&&t.closest('.jsort-sel')){
        e.preventDefault(); setOpen(root,true);
        var first=listOf(root).querySelector('.jsort-opt[aria-selected="true"]')
               || listOf(root).querySelector('.jsort-opt');
        if(first) first.focus();
      }
      return;
    }
    var opts=[].slice.call(listOf(root).querySelectorAll('.jsort-opt'));
    var cur=t.closest('.jsort-opt');
    var i=opts.indexOf(cur);
    if(e.key==='Escape'){ e.preventDefault(); setOpen(root,false); btnOf(root).focus(); return; }
    if(e.key==='ArrowDown'){ e.preventDefault(); (opts[i+1]||opts[0]).focus(); return; }
    if(e.key==='ArrowUp'){ e.preventDefault(); (opts[i-1]||opts[opts.length-1]).focus(); return; }
    if((e.key==='Enter'||e.key===' ')&&cur){ e.preventDefault(); choose(root,cur); return; }
  });
})();
